<template>
  <div class="card">
    <div class="card-header ch-alt">
      <h2>
        {{ $t('Remove job') }}
      </h2>
    </div>
    <div v-if="!$apollo.loading" class="card-body card-padding row">
      <div class="col-sm-8 col-sm-offset-2">
        <div class="alert alert-warning">
          <strong>{{ $t("You're about to remove a job") }}</strong>
          <p class="lead">{{ job.name }}</p>
        </div>
        <BaseHtmlForm
          v-if="job.dialogsAmount > 0"
          v-slot="{ submit }"
          :action="`/job/${jobId}`"
          method="DELETE"
        >
          <input type="hidden" name="removejob" value="1" />
          <div class="form-group">
            <label class="label-lg">{{ $t('Select a reason') }}</label>
            <div
              v-for="(value, key) of messageContent"
              :key="key"
              class="radio"
              :class="{ disabled: noMessage }"
            >
              <label>
                <input :id="key" v-model="cause" type="radio" :value="key" :disabled="noMessage" />
                {{ $t(value.label) }}
                <i class="input-helper"></i>
              </label>
            </div>
          </div>
          <div v-show="cause !== ''" v-if="job.dialogs.paginatorInfo.count > 0" class="form-group">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p v-html="activeConversationsHTML"></p>
            <label class="label-lg">{{ $t('Attached message for freelancers') }}</label>
            <textarea
              id="textarea-message"
              v-model="message"
              name="message"
              class="form-control"
              :placeholder="$t('Write a message to the freelancers')"
              :disabled="noMessage"
              rows="3"
            />
            <label class="m-t-5 small">
              <InputCheckbox v-model="noMessage" name="no_message">
                {{
                  $t("Don't send a message (e.g. if you're the one who wrote the latest message)")
                }}
              </InputCheckbox>
            </label>
          </div>
          <br />
          <div class="text-center">
            <BaseButton size="lg" color="success" :disabled="!submitReady" @click="submit">
              {{ $t('Close the job') }}
            </BaseButton>
          </div>
        </BaseHtmlForm>

        <hr />

        <br />
        <a :href="`/job/${jobId}`" class="btn btn-default btn-md">&laquo; {{ $t('Undo') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import BaseHtmlForm from '@/components/BaseHtmlForm.vue'
import InputCheckbox from '@/components/InputCheckbox.vue'
import BaseButton from '@/components/BaseButton.vue'

export default {
  components: {
    BaseHtmlForm,
    InputCheckbox,
    BaseButton,
  },
  apollo: {
    job: {
      query: gql`
        query job($localId: Int!) {
          job: yjob(localId: $localId) {
            globalId
            localId
            name
            dialogsAmount
            dialogs(type: OPEN) {
              paginatorInfo {
                count
              }
            }
          }
        }
      `,
      variables() {
        return {
          localId: parseInt(this.jobId, 10),
        }
      },
    },
  },
  props: {
    messageContent: {
      type: Object,
      default() {
        return {}
      },
    },
    jobId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      message: '',
      cause: '',
      message_is_changed: false,
      noMessage: false,
    }
  },
  computed: {
    submitReady() {
      return !!this.cause
    },
    activeConversationsHTML() {
      return $t(
        'You have <strong class="c-indigo">:count</strong> active conversations about this job <br> When you remove the job, we will automatically show a notification to the freelancers you\'ve been in contact with.',
        { count: this.job.dialogs.paginatorInfo.count },
      )
    },
  },

  watch: {
    cause() {
      if (this.message_is_changed && !confirm($t('Do you want to overwrite your text message?'))) {
        return
      }
      this.message = $t(this.messageContent[this.cause]?.message)
    },
    message() {
      this.message_is_changed = this.message !== $t(this.messageContent[this.cause]?.message)
    },
  },
}
</script>
